import { HttpHeaders } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { User } from 'src/app/model/settings/user.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private path = environment.apiURL + 'user';

  constructor(private http: HttpClient) {
  }

  public list(staff?: boolean): Observable<Array<User>> {
    let headers = new HttpHeaders();

    if (staff){
      headers = headers.append('staff', 'true');
    }

    return this.http
               .get<User[]>(this.path,
                            {headers});
  }

  public invite(email: string,
                role: number): Observable<void> {

    let params = new HttpParams().set('email', email)
                                 .set('role', role.toString());

    return this.http
               .put<void>(this.path + '/invite',
                            {},
                            {params});
  }

  public save(user: User): Observable<Array<User>> {
    return this.http
               .put<User[]>(this.path,
                            user);
  }

  public accept(token: string,
                user: User): Observable<void> {
    let header: HttpHeaders = new HttpHeaders();

    header = header.append('Authorization', token);

    return this.http.post<void>(this.path + '/accept',
                                user,
                                {headers: header});
  }

  public delete(user: User): Observable<void> {
    return this.http
               .delete<void>(this.path + '/' + user.userId);
  }

  public isRoot(user: User): boolean {
    return user.access === 1;
  }

  public isPortalAdmin(user: User): boolean {
      return user.access === 2;
  }

  public isPortalSupport(user: User): boolean {
      return user.access === 3;
  }

  public isPortalStaff(user: User): boolean {
      return this.isRoot(user) || this.isPortalSupport(user) || this.isPortalAdmin(user);
  }

  public isPartnerStaff(user: User): boolean {
      return this.isPartnerMain(user) || this.isPartnerRep(user);
  }

  public isPartnerMain(user: User): boolean {
      return user.access === 4;
  }

  public isPartnerRep(user: User): boolean {
      return user.access === 5;
  }

  public typeLabel(type: number): string {
    let label = '';

    switch(type){
      case 1:
        label = 'Root';
        break;

      case 2:
        label = 'Admin';
        break;

      case 3:
        label = 'Staff';
        break;

      case 4:
        label = 'Partner';
        break;

      case 5:
        label = 'Representative';
        break;
    }

    return label;
  }

  public staffLabel(type: number): string {
    let label = '';

    switch(type){
      case 1:
        label = 'Root';
        break;

      case 2:
        label = 'Admin';
        break;

      case 3:
        label = 'Support';
        break;
    }

    return label;
  }
}
